import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=3399678c&scoped=true&"
import script from "./MediaUpload.vue?vue&type=script&lang=ts&"
export * from "./MediaUpload.vue?vue&type=script&lang=ts&"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=3399678c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3399678c",
  null
  
)

export default component.exports